import React from 'react';
import './RetryButton.css';

interface RetryButtonProps {
  onRetry: () => void;
  loading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const RetryButton: React.FC<RetryButtonProps> = ({
  onRetry,
  loading = false,
  disabled = false,
  children = 'Try Again',
  variant = 'primary',
  size = 'medium',
  className = '',
}) => {
  return (
    <button
      className={`retry-button ${variant} ${size} ${className}`}
      onClick={onRetry}
      disabled={disabled || loading}
      aria-label={loading ? 'Retrying...' : 'Retry operation'}
    >
      {loading ? (
        <>
          <svg 
            className="retry-button-spinner" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56"/>
          </svg>
          <span>Retrying...</span>
        </>
      ) : (
        <>
          <svg 
            className="retry-button-icon" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <polyline points="23,4 23,10 17,10"/>
            <polyline points="1,20 1,14 7,14"/>
            <path d="m3.51,9a9,9,0,0,1,14.85-3.36L23,10M1,14l4.64,4.36A9,9,0,0,0,20.49,15"/>
          </svg>
          <span>{children}</span>
        </>
      )}
    </button>
  );
};

export default RetryButton;